function firstNonEmpty(...values) {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
}

function resolveWebApiBaseUrl() {
  const configured = firstNonEmpty(process.env.REACT_APP_API_BASE_URL, process.env.TIMR_API_BASE_URL);
  if (configured) {
    return configured;
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'file:') {
    return 'http://127.0.0.1:8000';
  }

  return process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
}

function resolveMobileApiBaseUrl() {
  const configured = firstNonEmpty(process.env.EXPO_PUBLIC_API_BASE_URL, process.env.TIMR_API_BASE_URL);
  if (configured) {
    return configured;
  }

  // Android emulator localhost mapping to host machine backend.
  return 'http://10.0.2.2:8000';
}

export function resolveTimrApiBaseUrl(target) {
  if (target === 'mobile') {
    return resolveMobileApiBaseUrl();
  }
  return resolveWebApiBaseUrl();
}
